import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionProvider } from '../../core/providers/session.provider';

@Injectable()
export class JWTApiInterceptor implements HttpInterceptor {
    constructor(
        private session: SessionProvider) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.session.getToken();
        if (token !== undefined) {
            req = req.clone({
                setHeaders: { 'Authorization': `Bearer ${token}` }
            });
        }

        return next.handle(req);
    }
}
